import { render, staticRenderFns } from "./ImportOldOppOverviewNote.vue?vue&type=template&id=715046a1&scoped=true&"
import script from "./ImportOldOppOverviewNote.vue?vue&type=script&lang=js&"
export * from "./ImportOldOppOverviewNote.vue?vue&type=script&lang=js&"
import style0 from "./ImportOldOppOverviewNote.vue?vue&type=style&index=0&id=715046a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715046a1",
  null
  
)

export default component.exports